import { useEffect } from 'react';

import { useLocation, useSearchParams } from '@remix-run/react';

const useRemoveDraftPreviewCookie = () => {
  const { pathname } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const shouldCloseDraftPreview = searchParams.get('close_draft_preview') || searchParams.get('orchid_v1');

    if (shouldCloseDraftPreview) {
      const hasPreviewCookie = document.cookie.split('; ').some((cookie) => cookie.startsWith('v2-preview='));

      if (hasPreviewCookie) {
        window.location.href = `/preview/exit?page=${pathname}`;
      } else {
        searchParams.delete('close_draft_preview');
        setSearchParams(searchParams);
      }
    }
  }, [searchParams, pathname, setSearchParams]);
};

export default useRemoveDraftPreviewCookie;
